import { Box, Button, Heading, Link } from '@primer/react';
import * as React from 'react';
export default {
  Box,
  Button,
  Heading,
  Link,
  React
};